import {
  Button,
  CounterBadge,
  Icon,
  Modal,
  SlideOut,
  Toggle,
  Typography,
} from '@globalmed/atlas-ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OnDemandNotifications.module.css';
import { OnDemandNotificationsItem } from './components';
import { useOnDemandAppointments } from './hooks/useOnDemandAppointments';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';

export const OnDemandNotifications = () => {
  const isSmallScreen = useMediaQuery('(max-width: 576px)');
  const ModalComponent = isSmallScreen ? Modal : SlideOut;

  const { t } = useTranslation();

  const {
    loading,
    onAppointmentAccept,
    onAppointmentDecline,
    isAvailable,
    isAvailableDisabled,
    handleToggleChange,
    appointmentsOnDemand,
    openSlideout,
    setOpenSlideout,
  } = useOnDemandAppointments();

  const isShowAppointments = isAvailable && !isAvailableDisabled;

  useEffect(() => {
    const flag = localStorage.getItem(LOCAL_STORAGE_KEYS.OPEN_ON_DEMAND);
    if (flag === '1') {
      setOpenSlideout(true);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.OPEN_ON_DEMAND);
    }
  }, [setOpenSlideout]);

  return (
    <>
      <CounterBadge
        count={isShowAppointments ? appointmentsOnDemand.length : 0}
        color="primary"
        size="sm"
        sx={{ margin: '20px 20px 0 0' }}
        maxView={99}
      >
        <Button
          preIcon="OnDemand"
          variant="secondary"
          text={isSmallScreen ? undefined : t('common.on-demand-requests')}
          onClick={() => setOpenSlideout(true)}
        />
      </CounterBadge>
      <ModalComponent
        open={openSlideout}
        onOpenChange={() => setOpenSlideout(false)}
        size="full"
        className={styles.modal}
        title={
          <div className={styles.modalTitleWrapper}>
            <div className={styles.modalTitle}>
              <Icon
                name="OnDemand"
                color="var(--colors-warning600)"
                size="20px"
              />
              <Typography fontSize="16px" fontWeight={600}>
                {t('common.on-demand-requests')}
              </Typography>
            </div>
            <Toggle
              label={t('dashboard.available')}
              checked={isAvailable}
              disabled={isAvailableDisabled}
              onChange={handleToggleChange}
            />
          </div>
        }
        body={
          <div className={styles.modalBody}>
            {isShowAppointments &&
              appointmentsOnDemand.map((appointment) => (
                <OnDemandNotificationsItem
                  key={appointment.id}
                  appointment={appointment}
                  onAppointmentAccept={onAppointmentAccept}
                  onAppointmentDecline={onAppointmentDecline}
                  loading={loading}
                />
              ))}
          </div>
        }
      />
    </>
  );
};
